export default "__VITE_ASSET__MyVA_A3F__"